import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "6",
            ry: "6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "12", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ToggleLeft";
const ToggleLeft = memo(themed(Icon));
export {
  ToggleLeft
};
//# sourceMappingURL=toggle-left.js.map
